"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLiveChatVisibility = void 0;
var widget_react_1 = require("@livechat/widget-react");
var swr_hooks_1 = require("@l2p/swr-hooks");
var useLiveChatVisibility = function () {
    var state = (0, widget_react_1.useWidgetState)();
    var changeHelpDeskStatus = (0, swr_hooks_1.useHelpDeskState)().changeHelpDeskStatus;
    return function () {
        var ChatWindow = window;
        if (!ChatWindow.LC_API.open_chat_window)
            return changeHelpDeskStatus(true);
        if (!(state === null || state === void 0 ? void 0 : state.visibility))
            return;
        if ((state === null || state === void 0 ? void 0 : state.visibility) !== 'maximized')
            ChatWindow.LC_API.open_chat_window();
        else
            ChatWindow.LC_API.hide_chat_window();
    };
};
exports.useLiveChatVisibility = useLiveChatVisibility;
